import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import history from '../history';
import { AUTH_TOKEN } from 'redux/constants/Auth';
import { notification } from 'antd';
import { env } from 'configs/EnvironmentConfig';
import setNotification from 'components/shared-components/Notification';
import Cookies from 'universal-cookie';

const apiService = axios.create({
  timeout: 60000,
});

// API Request interceptor
apiService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Auth error response
    if (
      error?.response?.data?.message === 'Session expired.' ||
      error?.response?.data?.message === 'Unauthorized Session.' ||
      error?.response?.data?.message === 'Unauthorized'
    ) {
      setNotification({
        type: 'error',
        message: 'Session expired.',
        description: 'Session expired, please login again',
      });
      sessionStorage.clear();
      localStorage.clear();
      const cookies = new Cookies();
      cookies.remove('tomei-price-sid', { path: '/' });
      // Redirect to login instead of reloading to prevent infinite loop
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  },
);

export function errorHandler(error, customMessage = '') {
  let message = customMessage || 'An error occurred';
  if (error.response) {
    let response = error.response;
    if (response.data && response.data.message) {
      message = response.data.message;
    } else if (typeof response.data === 'string') {
      message = response.data;
    } else if (response.message) {
      message = response.message;
    }
  }
  setNotification({
    message: message,
    type: 'error',
    description: '',
  });
}

export default apiService;
